export default __webpack_public_path__ + "static/media/cosyfish-logo.d75123c4.webp";